import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import Warning from '@material-ui/icons/Warning';
import {
  Stepper,
  Step,
  StepButton,
  Typography,
  makeStyles,
} from '@material-ui/core';
import PATHS from 'constants/paths';

const STEPS = {
  base: {
    title: (
      <FormattedMessage
        id="Base information"
        defaultMessage="Base information"
      />
    ),
  },
  text: {
    title: (
      <FormattedMessage
        id="Texts"
        defaultMessage="Texts"
      />
    ),
  },
  position: {
    title: (
      <FormattedMessage
        id="PositionMap"
        defaultMessage="Address / Map"
      />
    ),
  },
  location: {
    title: (
      <FormattedMessage
        id="Location"
        defaultMessage="Location"
      />
    ),
  },
  amenities: {
    title: (
      <FormattedMessage
        id="Amenities"
        defaultMessage="Amenities"
      />
    ),
  },
  pricing: {
    title: (
      <FormattedMessage
        id="Pricing"
        defaultMessage="Pricing"
      />
    ),
  },
  calendar: {
    title: (
      <FormattedMessage
        id="Calendar"
        defaultMessage="Calendar"
      />
    ),
  },
  images: {
    title: (
      <FormattedMessage
        id="Images"
        defaultMessage="Images"
      />
    ),
  },
  verify: {
    title: (
      <FormattedMessage
        id="Verify your ad"
        defaultMessage="Verify your ad"
      />
    ),
    disabled: (c) => {
      return c && (c.verified_by === 'BANKID' || c.verified_by === 'BOTH');
    },
  },
};

const styles = makeStyles((theme) => ({
  step: {
    display: 'flex',
  },
  stepButton: {
    padding: theme.spacing(2),
    margin: -theme.spacing(1) * 2,
    flex: 1,
    justifyContent: 'flex-start',
  },
  required: {
    display: 'inline',
    marginLeft: theme.spacing(1),
  },
}));

const CottageFormSteps = ({
  completedArray,
  requiredSteps,
  cottage,
  currentStep,
}) => {
  const classes = styles();
  const history = useHistory();

  return (
    <Stepper nonLinear orientation="vertical">
      {Object.keys(STEPS).map((step) => {
        const required = completedArray && requiredSteps.includes(step) && !completedArray.includes(step);
        const stepProps = {};

        if (required) {
          stepProps.icon = <Warning color="error" />;
        }

        if (STEPS[step].disabled) {
          stepProps.disabled = STEPS[step].disabled(cottage);
        }

        return (
          <Step
            key={step}
            active={step === currentStep}
            className={classes.step}
          >
            <StepButton
              onClick={() => {
                if (!cottage || !cottage.id) {
                  return null;
                }

                return history.push(PATHS.cottages.editStep.replace(':cottageId', cottage.id).replace(':dialog', step));
              }}
              className={classes.stepButton}
              completed={completedArray.includes(step)}
              {...stepProps}
            >
              {STEPS[step].title}
              {required && (
                <Typography
                  variant="caption"
                  color="error"
                  className={classes.required}
                >
                  <FormattedMessage
                    id="Required"
                    defaultMessage="Required"
                  />
                </Typography>
              )}
            </StepButton>
          </Step>
        );
      })}
    </Stepper>
  );
};

CottageFormSteps.propTypes = {
  completedArray: PropTypes.arrayOf(PropTypes.string),
  requiredSteps: PropTypes.arrayOf(PropTypes.string),
  cottage: PropTypes.shape({
    id: PropTypes.number,
  }),
  currentStep: PropTypes.string,
};

export default CottageFormSteps;
